import { media, styled, typography } from '@pulse-web-ui/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Labels = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  flex: 1;
  min-width: 0;
`;

export const Label = styled.div<{ $isCurrent: boolean }>`
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: 8px;
  display: ${({ $isCurrent }) => ($isCurrent ? 'flex' : 'none')};

  ${media.desktop} {
    display: flex;
  }
`;

export const LabelIconContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  color: ${({ theme }) => theme.colors.icon.primary};
  background-color: ${({ theme }) => theme.colors.neutral[0]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[30]};
  border-radius: 50%;
  box-sizing: border-box;
`;

export const LabelText = styled.div`
  ${typography.regular14};
  flex: 1 1 auto;
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Tracks = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

export const Track = styled.div`
  width: 100%;
  height: 4px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.neutral[20]};
  border-radius: 4px;
`;

export const TrackProgress = styled.div<{ $progress: number }>`
  width: ${({ $progress }) => $progress * 100}%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.accent.action.normal};
  transition: width 300ms ease-in-out;
`;
